<template>
  <div>
    <el-dropdown size="small" class="d2-mr">
      <span class="btn-text">{{info.name ? `你好 ${info.name}` : '未登录'}}</span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item @click.native="dialogFormVisible = true">
          <d2-icon name="power-off" class="fa fa-key"/>
          修改密码
        </el-dropdown-item>
        <el-dropdown-item @click.native="logOff">
          <d2-icon name="power-off" class="d2-mr-5"/>
          注销
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <el-dialog title="密码修改"   width="30%" :visible.sync="dialogFormVisible">
      <el-form :model="sysUser">
        <el-form-item label="登录账号">
          <el-input v-model="sysUser.userName" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="新的密码">
          <el-input placeholder="请输入新的密码" @input="verification"  v-model="sysUser.passWord" show-password></el-input>
          <el-input placeholder="请再次输入新的密码" v-model="sysUser.passWordNew" style="margin-top: 5px" show-password></el-input>
          <el-alert
            v-if="areTheyEqual"
            title="两次密码不相同，请检查！"
            type="error"
            show-icon>
          </el-alert>
          <el-alert
            v-if="pwdLength"
            title="密码长度必须大于 6 位！"
            type="error"
            show-icon>
          </el-alert>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateUserPwd">确 定</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
    import {mapState, mapActions} from 'vuex'
    import {updateUserPwd} from '@/api/sys.user'
    import util from "@/libs/util";
    import qs from 'qs'

    export default {
        data() {
            return {
                dialogFormVisible: false,
                sysUser: {
                    userName: '',
                    passWord: null,
                    passWordNew: null
                },
                areTheyEqual: false,
                pwdLength: false
            }
        },
        computed: {
            ...mapState('d2admin/user', [
                'info'
            ])
        },
        mounted () {
            let username = util.cookies.get('username');
            this.sysUser.userName = username
        },
        methods: {
            ...mapActions('d2admin/account', [
                'logout'
            ]),
            /**
             * @description 登出
             */
            logOff() {
                this.logout({
                    confirm: true
                })
            },
            /**
             * @description 登出
             */
            timeOff() {
                util.cookies.remove('uuid')
                util.cookies.remove('token')
                util.cookies.remove('areaid')
                util.cookies.remove('roleId')
                util.cookies.remove('username')
                util.cookies.remove('userId')
                this.$router.push({
                    name: 'login'
                })
            },
            updateUserPwd() {
                if(this.sysUser.passWordNew  === this.sysUser.passWord){
                    this.areTheyEqual = false
                    updateUserPwd(qs.stringify(this.sysUser)).then(res => {
                        this.dialogFormVisible = false
                        this.$alert('修改密码成功，需重新登录！', '提示', {
                            confirmButtonText: '确定',
                            center: true,
                            callback: action => {
                                this.timeOff()
                            }
                        });
                    }).catch(err => {

                    })
                }else {
                    // 两次不匹配
                    this.areTheyEqual = true
                }
            },
            verification () {
                console.log(this.sysUser.passWord.length)
                if(this.sysUser.passWord.length < 6){
                    this.pwdLength = true
                }else {
                    this.pwdLength = false
                }
            }
        }
    }
</script>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/layout/header-aside/components/header-user/index.vue"
}
</vue-filename-injector>
